var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardUiPaymentMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41,7H7c-2.7568359,0-5,2.2431641-5,5v9v15c0,2.7568359,2.2431641,5,5,5h34c2.7568359,0,5-2.2431641,5-5V21v-9 C46,9.2431641,43.7568359,7,41,7z M4,15h40v4H4V15z M44,36c0,1.6542969-1.3457031,3-3,3H7c-1.6542969,0-3-1.3457031-3-3V21h40V36z  M4,13v-1c0-1.6542969,1.3457031-3,3-3h34c1.6542969,0,3,1.3457031,3,3v1H4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,35h6c1.1030273,0,2-0.8974609,2-2v-6c0-1.1025391-0.8969727-2-2-2h-6c-1.1030273,0-2,0.8974609-2,2v6 C8,34.1025391,8.8969727,35,10,35z M10,27h6v6h-6V27z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 25,
    width: 15,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 29,
    width: 8,
    height: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardUiPaymentMedium);
export default __webpack_public_path__ + "static/media/card-ui-payment--medium.626d07a68dab7bc036fab81833467143.svg";
export { ForwardRef as ReactComponent };